module.exports = __webpack_public_path__ + "static/media/Ela1.8a9d77e5.webp";